/* ----------------------------------------------- */
/* ----------------- AUTH ------------------------ */
/* ----------------------------------------------- */
export const AUTH_USER_SUCCESS = 'okta/loginUserWithUserId/fulfilled';
export const AUTH_USER_REQUEST = 'okta/loginUserWithUserId/pending';
export const AUTH_USER_FAILURE = 'okta/loginUserWithUserId/rejected';
export const AUTH_GETMFA_SUCCESS = 'AUTH_GETMFA_SUCCESS';
export const AUTH_MISSING_MFA_CODE = 'AUTH_MISSING_MFA_CODE';
export const RESET_MFA_TOKEN_REQUEST = 'RESET_MFA_TOKEN_REQUEST';
export const RESET_MFA_TOKEN_SUCCESS = 'RESET_MFA_TOKEN_SUCCESS';
export const RESET_MFA_TOKEN_FAILURE = 'RESET_MFA_TOKEN_FAILURE';
export const AUTH_RESET_MFA_REQUEST = 'AUTH_RESET_MFA_REQUEST';
export const AUTH_RESET_MFA_SUCCESS = 'AUTH_RESET_MFA_SUCCESS';
export const AUTH_RESET_MFA_FAILURE = 'AUTH_RESET_MFA_FAILURE';
export const UNAUTH_USER = 'UNAUTH_USER';
export const SET_ROOT_APP = 'SET_ROOT_APP';
export const RESET_AUTH_STATE = 'RESET_AUTH_STATE';
export const REFRESH_USER_TOKEN = 'REFRESH_USER_TOKEN';
export const REHYDRATE = 'persist/REHYDRATE';
export const SET_BASE_URL = 'SET_BASE_URL';
export const SET_LANGUAGE_PREF = 'SET_LANGUAGE_PREF';
export const AUTH_ACCEPT_AF_TERMS = 'AUTH_ACCEPT_AF_TERMS';
export const SET_RESET_PASSWORD_TOKEN = 'SET_RESET_PASSWORD_TOKEN';
export const OKTA_AUTH_SUCCESS = 'okta/oktaAuthSuccess';
export const SET_MIL_ENV = 'SET_MIL_ENV';

export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const SET_WS_CONNECTED = 'SET_WS_CONNECTED';

export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_REQUEST = 'DELETE_ACCOUNT_REQUEST';
export const DELETE_ACCOUNT_FAILURE = 'DELETE_ACCOUNT_FAILURE';

export const FB_REMOVE_FOLLOWER = 'FB_REMOVE_FOLLOWER';

export const AUTH_FORGOT_PASSWORD_REQUEST = 'AUTH_FORGOT_PASSWORD_REQUEST',
  AUTH_FORGOT_PASSWORD_SUCCESS = 'AUTH_FORGOT_PASSWORD_SUCCESS',
  AUTH_FORGOT_PASSWORD_FAILURE = 'AUTH_FORGOT_PASSWORD_FAILURE',
  AUTH_RESET_PASSWORD_REQUEST = 'AUTH_RESET_PASSWORD_REQUEST',
  AUTH_RESET_PASSWORD_SUCCESS = 'AUTH_RESET_PASSWORD_SUCCESS',
  AUTH_RESET_PASSWORD_FAILURE = 'AUTH_RESET_PASSWORD_FAILURE';

export const AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_REQUEST =
    'AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_REQUEST',
  AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_SUCCESS = 'AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_SUCCESS',
  AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_FAILURE = 'AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_FAILURE',
  AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_REQUEST =
    'AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_REQUEST',
  AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_SUCCESS =
    'AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_SUCCESS',
  AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_FAILURE =
    'AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_FAILURE';

/* ----------------------------------------------- */
/* --------------- PROFILE ----------------------- */
/* ----------------------------------------------- */

export const PROFILE_USER_PHOTO_PRE_SIGN_URL_FOR_UPLOAD_REQUEST =
    'PROFILE_USER_PHOTO_PRE_SIGN_URL_FOR_UPLOAD_REQUEST',
  PROFILE_USER_PHOTO_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS =
    'PROFILE_USER_PHOTO_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS',
  PROFILE_USER_PHOTO_PRE_SIGN_URL_FOR_UPLOAD_FAILURE =
    'PROFILE_USER_PHOTO_PRE_SIGN_URL_FOR_UPLOAD_FAILURE',
  PROFILE_USER_PHOTO_UPLOAD_FILE_REQUEST = 'PROFILE_USER_PHOTO_UPLOAD_FILE_REQUEST',
  PROFILE_USER_PHOTO_UPLOAD_FILE_SUCCESS = 'PROFILE_USER_PHOTO_UPLOAD_FILE_SUCCESS',
  PROFILE_USER_PHOTO_UPLOAD_FILE_FAILURE = 'PROFILE_USER_PHOTO_UPLOAD_FILE_FAILURE';

export const FB_PROFILE_FOLLOWER_UPDATED_REQUEST = 'FB_PROFILE_FOLLOWER_UPDATED_REQUEST';
export const FB_PROFILE_FOLLOWER_UPDATED_SUCCESS = 'FB_PROFILE_FOLLOWER_UPDATED_SUCCESS';
export const FB_PROFILE_FOLLOWER_UPDATED_FAILURE = 'FB_PROFILE_FOLLOWER_UPDATED_FAILURE';

export const FB_PROFILE_OWN_USER_UPDATED_REQUEST = 'FB_PROFILE_OWN_USER_UPDATED_REQUEST';
export const FB_PROFILE_OWN_USER_UPDATED_SUCCESS = 'FB_PROFILE_OWN_USER_UPDATED_SUCCESS';
export const FB_PROFILE_OWN_USER_UPDATED_FAILURE = 'FB_PROFILE_OWN_USER_UPDATED_FAILURE';

export const PROFILE_OWN_USER_UPDATED_REQUEST = 'PROFILE_OWN_USER_UPDATED_REQUEST';
export const PROFILE_OWN_USER_UPDATED_SUCCESS = 'PROFILE_OWN_USER_UPDATED_SUCCESS';
export const PROFILE_OWN_USER_UPDATED_FAILURE = 'PROFILE_OWN_USER_UPDATED_FAILURE';

export const PROFILE_OWN_USER_UPDATE_AVATAR_REQUEST = 'PROFILE_OWN_USER_UPDATE_AVATAR_REQUEST';
export const PROFILE_OWN_USER_UPDATE_AVATAR_SUCCESS = 'PROFILE_OWN_USER_UPDATE_AVATAR_SUCCESS';
export const PROFILE_OWN_USER_UPDATE_AVATAR_FAILURE = 'PROFILE_OWN_USER_UPDATE_AVATAR_FAILURE';

export const RESET_PROFILE_STATE = 'RESET_PROFILE_STATE';

/* ----------------------------------------------- */
/* ----------------- SYNC ------------------------ */
/* ----------------------------------------------- */

export const COLD_START_FINISHED = 'COLD_START_FINISHED',
  FULL_SYNC_SUCCESS = 'FULL_SYNC_SUCCESS',
  FORCE_FULL_SYNC = 'FORCE_FULL_SYNC',
  CLEAR_ALL_STATE = 'CLEAR_ALL_STATE',
  SET_REFERRER = 'SET_REFERRER',
  WEBSOCKET_UPDATE_TIMESTAMP = 'WEBSOCKET_UPDATE_TIMESTAMP';

/* ----------------------------------------------- */
/* ---------------- INVITES ---------------------- */
/* ----------------------------------------------- */
export const INVITES_SEND_REQUEST = 'INVITES_SEND_REQUEST',
  INVITES_SEND_SUCCESS = 'INVITES_SEND_SUCCESS',
  INVITES_SEND_FAILURE = 'INVITES_SEND_FAILURE',
  INVITES_GET_ACCEPT_REQUEST = 'INVITES_GET_ACCEPT_REQUEST',
  INVITES_GET_ACCEPT_SUCCESS = 'INVITES_GET_ACCEPT_SUCCESS',
  INVITES_GET_ACCEPT_FAILURE = 'INVITES_GET_ACCEPT_FAILURE',
  INVITES_POST_ACCEPT_REQUEST = 'INVITES_POST_ACCEPT_REQUEST',
  INVITES_POST_ACCEPT_SUCCESS = 'INVITES_POST_ACCEPT_SUCCESS',
  INVITES_POST_ACCEPT_FAILURE = 'INVITES_POST_ACCEPT_FAILURE',
  RESET_INVITES_STATE = 'RESET_INVITES_STATE',
  INVITE_GUID = 'INVITE_GUID',
  INVITE_AUTH_DETAILS_REQUEST = 'INVITE_AUTH_DETAILS_REQUEST',
  INVITE_AUTH_DETAILS_SUCCESS = 'INVITE_AUTH_DETAILS_SUCCESS',
  INVITE_AUTH_DETAILS_FAILURE = 'INVITE_AUTH_DETAILS_FAILURE';

// FIREBASE //

/* ----------------------------------------------- */
/* ----------------- CASES ----------------------- */
/* ----------------------------------------------- */
export const CASE_ADD_REQUEST = 'CASE_ADD_REQUEST',
  CASE_ADD_SUCCESS = 'CASE_ADD_SUCCESS',
  CASE_ADD_FAILURE = 'CASE_ADD_FAILURE',
  CASE_SHOW_MODAL = 'CASE_SHOW_MODAL',
  CASE_HIDE_MODAL = 'CASE_HIDE_MODAL',
  CASE_HIDE_SNACKBAR = 'CASE_HIDE_SNACKBAR',
  CASE_GET_BY_USER_REQUEST = 'CASE_GET_BY_USER_REQUEST',
  CASE_GET_BY_USER_SUCCESS = 'CASE_GET_BY_USER_SUCCESS',
  CASE_GET_BY_USER_FAILURE = 'CASE_GET_BY_USER_FAILURE',
  CASE_GET_BY_CASE_ID_REQUEST = 'CASE_GET_BY_CASE_ID_REQUEST',
  CASE_GET_BY_CASE_ID_SUCCESS = 'CASE_GET_BY_CASE_ID_SUCCESS',
  CASE_GET_BY_CASE_ID_FAILURE = 'CASE_GET_BY_CASE_ID_FAILURE',
  SET_CURRENT_CASE_ID = 'SET_CURRENT_CASE_ID',
  RESET_CASE_STATE = 'RESET_CASE_STATE',
  RESET_CASE_STATUS = 'RESET_CASE_STATUS',
  CASE_LEAVE_REQUEST = 'CASE_LEAVE_REQUEST',
  CASE_LEAVE_SUCCESS = 'CASE_LEAVE_SUCCESS',
  CASE_LEAVE_FAILURE = 'CASE_LEAVE_FAILURE',
  CASE_UPDATE_REQUEST = 'CASE_UPDATE_REQUEST',
  CASE_UPDATE_SUCCESS = 'CASE_UPDATE_SUCCESS',
  CASE_UPDATE_FAILURE = 'CASE_UPDATE_FAILURE',
  CASE_INFO = 'CASE_INFO',
  CASE_CANCEL_AIRFORCE_READINESS_REQUEST = 'CASE_CANCEL_AIRFORCE_READINESS_REQUEST',
  CASE_CANCEL_AIRFORCE_READINESS_SUCCESS = 'CASE_CANCEL_AIRFORCE_READINESS_SUCCESS',
  CASE_CANCEL_AIRFORCE_READINESS_FAILURE = 'CASE_CANCEL_AIRFORCE_READINESS_FAILURE',
  CASE_PARTICIPANT_EDIT_REQUEST = 'CASE_PARTICIPANT_EDIT_REQUEST',
  CASE_PARTICIPANT_EDIT_SUCCESS = 'CASE_PARTICIPANT_EDIT_SUCCESS',
  CASE_PARTICIPANT_EDIT_FAILURE = 'CASE_PARTICIPANT_EDIT_FAILURE',
  CASE_SEARCH_REQUEST = 'CASE_SEARCH_REQUEST',
  CASE_SEARCH_SUCCESS = 'CASE_SEARCH_SUCCESS',
  CASE_SEARCH_FAILURE = 'CASE_SEARCH_FAILURE';

export const FB_CASE_USER_GET_NEW_PARTICIPANT_REQUEST = 'FB_CASE_USER_GET_NEW_PARTICIPANT_REQUEST',
  FB_CASE_USER_GET_NEW_PARTICIPANT_SUCCESS = 'FB_CASE_USER_GET_NEW_PARTICIPANT_SUCCESS',
  FB_CASE_USER_GET_NEW_PARTICIPANT_FAILURE = 'FB_CASE_USER_GET_NEW_PARTICIPANT_FAILURE',
  FB_REMOVE_PARTICIPANT = 'FB_REMOVE_PARTICIPANT',
  FB_CASE_LEAVE = 'FB_CASE_LEAVE',
  FB_CASE_GET_HEADER_INFO_REQUEST = 'FB_CASE_GET_HEADER_INFO_REQUEST',
  FB_CASE_GET_HEADER_INFO_SUCCESS = 'FB_CASE_GET_HEADER_INFO_SUCCESS',
  FB_CASE_GET_HEADER_INFO_FAILURE = 'FB_CASE_GET_HEADER_INFO_FAILURE';

/* ----------------------------------------------- */
/* --------------- CALENDAR ---------------------- */
/* ----------------------------------------------- */
export const CALENDAR_EVENT_ADD_REQUEST = 'CALENDAR_EVENT_ADD_REQUEST',
  CALENDAR_EVENT_ADD_SUCCESS = 'CALENDAR_EVENT_ADD_SUCCESS',
  CALENDAR_EVENT_ADD_FAILURE = 'CALENDAR_EVENT_ADD_FAILURE',
  CALENDAR_EVENT_EDIT_REQUEST = 'CALENDAR_EVENT_EDIT_REQUEST',
  CALENDAR_EVENT_EDIT_SUCCESS = 'CALENDAR_EVENT_EDIT_SUCCESS',
  CALENDAR_EVENT_EDIT_FAILURE = 'CALENDAR_EVENT_EDIT_FAILURE',
  CALENDAR_EVENT_MULTIPLE_ADD_REQUEST = 'CALENDAR_EVENT_MULTIPLE_ADD_REQUEST',
  CALENDAR_EVENT_MULTIPLE_ADD_SUCCESS = 'CALENDAR_EVENT_MULTIPLE_ADD_SUCCESS',
  CALENDAR_EVENT_MULTIPLE_ADD_FAILURE = 'CALENDAR_EVENT_MULTIPLE_ADD_FAILURE',
  CALENDAR_UNAVAILABLE_EVENT_ADD_REQUEST = 'CALENDAR_UNAVAILABLE_EVENT_ADD_REQUEST',
  CALENDAR_UNAVAILABLE_EVENT_ADD_SUCCESS = 'CALENDAR_UNAVAILABLE_EVENT_ADD_SUCCESS',
  CALENDAR_UNAVAILABLE_EVENT_ADD_FAILURE = 'CALENDAR_UNAVAILABLE_EVENT_ADD_FAILURE',
  RESET_CALENDAR_STATE = 'RESET_CALENDAR_STATE',
  SET_CURRENT_EVENT_ID = 'SET_CURRENT_EVENT_ID',
  SET_SCROLL_TO_DATE = 'SET_SCROLL_TO_DATE',
  SET_EDITING_EVENT_ID = 'SET_EDITING_EVENT_ID',
  SET_CALENDAR_VIEW_EMPLOYER = 'SET_CALENDAR_VIEW_EMPLOYER',
  CALENDAR_SET_SELECTED_CASES = 'CALENDAR_SET_SELECTED_CASES',
  CALENDAR_FETCH_REQUEST = 'CALENDAR_FETCH_REQUEST',
  CALENDAR_FETCH_SUCCESS = 'CALENDAR_FETCH_SUCCESS',
  CALENDAR_FETCH_FAILURE = 'CALENDAR_FETCH_FAILURE';

// FIREBASE //

export const FB_EMPLOYER_GET_REQUEST = 'FB_EMPLOYER_GET_REQUEST',
  FB_EMPLOYER_GET_FAILURE = 'FB_EMPLOYER_GET_FAILURE',
  FB_EMPLOYER_GET_SUCCESS = 'FB_EMPLOYER_GET_SUCCESS',
  FB_EMPLOYER_LEAVE = 'FB_EMPLOYER_LEAVE';

export const EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_REQUEST =
    'EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_REQUEST',
  EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_SUCCESS = 'EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_SUCCESS',
  EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_FAILURE = 'EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_FAILURE';

export const EMPLOYER_UPDATE_PHA_REQUEST_STATUS_REQUEST =
    'EMPLOYER_UPDATE_PHA_REQUEST_STATUS_REQUEST',
  EMPLOYER_UPDATE_PHA_REQUEST_STATUS_SUCCESS = 'EMPLOYER_UPDATE_PHA_REQUEST_STATUS_SUCCESS',
  EMPLOYER_UPDATE_PHA_REQUEST_STATUS_FAILURE = 'EMPLOYER_UPDATE_PHA_REQUEST_STATUS_FAILURE';

export const UPDATE_EMPLOYER_USER_REQUEST = 'UPDATE_EMPLOYER_USER_REQUEST',
  UPDATE_EMPLOYER_USER_FAILURE = 'UPDATE_EMPLOYER_USER_FAILURE',
  UPDATE_EMPLOYER_USER_SUCCESS = 'UPDATE_EMPLOYER_USER_SUCCESS';

export const SAVE_EMPLOYER_SETUP_DATA_REQUEST = 'SAVE_EMPLOYER_SETUP_DATA_REQUEST';
export const SAVE_EMPLOYER_SETUP_DATA_SUCCESS = 'SAVE_EMPLOYER_SETUP_DATA_SUCCESS';
export const SAVE_EMPLOYER_SETUP_DATA_FAILURE = 'SAVE_EMPLOYER_SETUP_DATA_FAILURE';
export const GET_EMPLOYER_SETUP_DATA_REQUEST = 'GET_EMPLOYER_SETUP_DATA_REQUEST';
export const GET_EMPLOYER_SETUP_DATA_SUCCESS = 'GET_EMPLOYER_SETUP_DATA_SUCCESS';
export const GET_EMPLOYER_SETUP_DATA_FAILURE = 'GET_EMPLOYER_SETUP_DATA_FAILURE';
export const DELETE_EMPLOYER_SETUP_DATA_REQUEST = 'DELETE_EMPLOYER_SETUP_DATA_REQUEST';
export const DELETE_EMPLOYER_SETUP_DATA_SUCCESS = 'DELETE_EMPLOYER_SETUP_DATA_SUCCESS';
export const DELETE_EMPLOYER_SETUP_DATA_FAILURE = 'DELETE_EMPLOYER_SETUP_DATA_FAILURE';
export const EMPLOYER_SETUP_DATA_UPDATED = 'EMPLOYER_SETUP_DATA_UPDATED';

export const EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_REQUEST =
    'EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_REQUEST',
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_SUCCESS = 'EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_SUCCESS',
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_FAILURE = 'EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_FAILURE',
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_REQUEST = 'EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_REQUEST',
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_SUCCESS = 'EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_SUCCESS',
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_FAILURE = 'EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_FAILURE',
  EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_REQUEST =
    'EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_REQUEST',
  EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_SUCCESS =
    'EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_SUCCESS',
  EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_FAILURE =
    'EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_FAILURE',
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_REQUEST = 'EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_REQUEST',
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_SUCCESS = 'EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_SUCCESS',
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_FAILURE = 'EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_FAILURE',
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_REQUEST = 'EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_REQUEST',
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_SUCCESS = 'EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_SUCCESS',
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_FAILURE = 'EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_FAILURE';

export const EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_REQUEST =
    'EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_REQUEST',
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_SUCCESS =
    'EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_SUCCESS',
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_FAILURE =
    'EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_FAILURE',
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_REQUEST =
    'EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_REQUEST',
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_SUCCESS =
    'EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_SUCCESS',
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_FAILURE =
    'EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_FAILURE';

export const RESET_EMPLOYER_STATUS = 'RESET_EMPLOYER_STATUS';

export const FB_CALENDAR_EVENT_GET_REQUEST = 'FB_CALENDAR_EVENT_GET_REQUEST',
  FB_CALENDAR_EVENT_GET_SUCCESS = 'FB_CALENDAR_EVENT_GET_SUCCESS',
  FB_CALENDAR_EVENT_GET_FAILURE = 'FB_CALENDAR_EVENT_GET_FAILURE',
  FB_CALENDAR_EVENT_REMOVE_SUCCESS = 'FB_CALENDAR_EVENT_REMOVE_SUCCESS',
  FB_CALENDAR_EVENT_FROM_FILE_CHANGE_GET_REQUEST = 'FB_CALENDAR_EVENT_FROM_FILE_CHANGE_GET_REQUEST',
  FB_CALENDAR_EVENT_FROM_FILE_CHANGE_GET_SUCCESS = 'FB_CALENDAR_EVENT_FROM_FILE_CHANGE_GET_SUCCESS',
  FB_CALENDAR_EVENT_FROM_FILE_CHANGE_GET_FAILURE = 'FB_CALENDAR_EVENT_FROM_FILE_CHANGE_GET_FAILURE';

/* ----------------------------------------------- */
/* --------------- MESSAGING --------------------- */
/* ----------------------------------------------- */
export const MESSAGING_GROUP_CHAT_ADD_REQUEST = 'MESSAGING_GROUP_CHAT_ADD_REQUEST',
  MESSAGING_GROUP_CHAT_ADD_SUCCESS = 'MESSAGING_GROUP_CHAT_ADD_SUCCESS',
  MESSAGING_GROUP_CHAT_ADD_FAILURE = 'MESSAGING_GROUP_CHAT_ADD_FAILURE',
  MESSAGING_TOPIC_ADD_REQUEST = 'MESSAGING_TOPIC_ADD_REQUEST',
  MESSAGING_TOPIC_ADD_SUCCESS = 'MESSAGING_TOPIC_ADD_SUCCESS',
  MESSAGING_TOPIC_ADD_FAILURE = 'MESSAGING_TOPIC_ADD_FAILURE',
  SET_CURRENT_TOPIC_ID = 'SET_CURRENT_TOPIC_ID',
  SET_CURRENT_MESSAGE_ID = 'SET_CURRENT_MESSAGE_ID',
  RESET_MESSAGING_STATE = 'RESET_MESSAGING_STATE',
  RESET_TOPIC_STATE = 'RESET_TOPIC_STATE',
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST =
    'MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST',
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS =
    'MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS',
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE =
    'MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE',
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_REQUEST = 'MESSAGING_GROUP_CHAT_UPLOAD_FILE_REQUEST',
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_SUCCESS = 'MESSAGING_GROUP_CHAT_UPLOAD_FILE_SUCCESS',
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_FAILURE = 'MESSAGING_GROUP_CHAT_UPLOAD_FILE_FAILURE',
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_REQUEST =
    'MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_REQUEST',
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_SUCCESS =
    'MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_SUCCESS',
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_FAILURE =
    'MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_FAILURE',
  MESSAGING_BROADCAST_ADD_REQUEST = 'MESSAGING_BROADCAST_ADD_REQUEST',
  MESSAGING_BROADCAST_ADD_SUCCESS = 'MESSAGING_BROADCAST_ADD_SUCCESS',
  MESSAGING_BROADCAST_ADD_FAILURE = 'MESSAGING_BROADCAST_ADD_FAILURE';
export const MESSAGING_TOPIC_UPDATE_REQUEST = 'MESSAGING_TOPIC_UPDATE_REQUEST';
export const MESSAGING_TOPIC_UPDATE_SUCCESS = 'MESSAGING_TOPIC_UPDATE_SUCCESS';
export const MESSAGING_TOPIC_UPDATE_FAILURE = 'MESSAGING_TOPIC_UPDATE_FAILURE';

export const MESSAGING_SET_NAV_MODE = 'MESSAGING_SET_NAV_MODE';
export const TOPICS_GET_BY_USER_REQUEST = 'TOPICS_GET_BY_USER_REQUEST';
export const TOPICS_GET_BY_USER_SUCCESS = 'TOPICS_GET_BY_USER_SUCCESS';
export const TOPICS_GET_BY_USER_FAILURE = 'TOPICS_GET_BY_USER_FAILURE';
export const MESSAGING_BROADCAST_TAPPED = 'MESSAGING_BROADCAST_TAPPED';
// FIREBASE //
export const FB_MESSAGING_GROUP_CHAT_GET_REQUEST = 'FB_MESSAGING_GROUP_CHAT_GET_REQUEST',
  FB_MESSAGING_GROUP_CHAT_GET_SUCCESS = 'FB_MESSAGING_GROUP_CHAT_GET_SUCCESS',
  FB_MESSAGING_GROUP_CHAT_GET_FAILURE = 'FB_MESSAGING_GROUP_CHAT_GET_FAILURE',
  FB_MESSAGING_TOPIC_GET_REQUEST = 'FB_MESSAGING_TOPIC_GET_REQUEST',
  FB_MESSAGING_TOPIC_GET_SUCCESS = 'FB_MESSAGING_TOPIC_GET_SUCCESS',
  FB_MESSAGING_TOPIC_GET_FAILURE = 'FB_MESSAGING_TOPIC_GET_FAILURE',
  FB_REMOVE_GROUP_MESSAGE = 'FB_REMOVE_GROUP_MESSAGE',
  MESSAGING_GROUP_CHAT_REMOVE_REQUEST = 'MESSAGING_GROUP_CHAT_REMOVE_REQUEST',
  MESSAGING_GROUP_CHAT_REMOVE_SUCCESS = 'MESSAGING_GROUP_CHAT_REMOVE_SUCCESS',
  MESSAGING_GROUP_CHAT_REMOVE_FAILURE = 'MESSAGING_GROUP_CHAT_REMOVE_FAILURE';

/* ----------------------------------------------- */
/* -------------- MEDICAL TEAM ------------------- */
/* ----------------------------------------------- */

export const RESET_MEDICAL_TEAM_STATE = 'RESET_PATIENT_MEDICAL_TEAM_STATE';

/* ----------------------------------------------- */
/* ---------------- SETTINGS --------------------- */
/* ----------------------------------------------- */

/* ----------------------------------------------- */
/* --------------- NOTIFICATIONS --------------------- */
/* ----------------------------------------------- */

export const NOTIFICATIONS_GET_ALL_REQUEST = 'NOTIFICATIONS_GET_ALL_REQUEST',
  NOTIFICATIONS_GET_ALL_SUCCESS = 'NOTIFICATIONS_GET_ALL_SUCCESS',
  NOTIFICATIONS_GET_ALL_FAILURE = 'NOTIFICATIONS_GET_ALL_FAILURE',
  NOTIFICATIONS_MARK_AS_READ_REQUEST = 'NOTIFICATIONS_MARK_AS_READ_REQUEST',
  NOTIFICATIONS_MARK_AS_READ_SUCCESS = 'NOTIFICATIONS_MARK_AS_READ_SUCCESS',
  NOTIFICATIONS_MARK_AS_READ_FAILURE = 'NOTIFICATIONS_MARK_AS_READ_FAILURE',
  NOTIFICATIONS_BADGE_NUMBER_CHANGED = 'NOTIFICATIONS_BADGE_NUMBER_CHANGED',
  NOTIFICATIONS_MARK_ALL_AS_READ_REQUEST = 'NOTIFICATIONS_MARK_ALL_AS_READ_REQUEST',
  NOTIFICATIONS_MARK_ALL_AS_READ_SUCCESS = 'NOTIFICATIONS_MARK_ALL_AS_READ_SUCCESS',
  NOTIFICATIONS_MARK_ALL_AS_READ_FAILURE = 'NOTIFICATIONS_MARK_ALL_AS_READ_FAILURE';

/* ----------------------------------------------- */
/* -------------- COMPONENTS --------------------- */
/* ----------------------------------------------- */
export const RESET_COMPONENT_STATE = 'RESET_COMPONENT_STATE',
  COMPONENT_UPLOAD_AND_SAVE_FILES_PENDING = 'COMPONENT_UPLOAD_AND_SAVE_FILES_PENDING',
  COMPONENT_UPLOAD_AND_SAVE_FILES_REQUEST = 'COMPONENT_UPLOAD_AND_SAVE_FILES_REQUEST',
  COMPONENT_UPLOAD_AND_SAVE_FILES_SUCCESS = 'COMPONENT_UPLOAD_AND_SAVE_FILES_SUCCESS',
  COMPONENT_UPLOAD_AND_SAVE_FILES_FAILURE = 'COMPONENT_UPLOAD_AND_SAVE_FILES_FAILURE',
  COMPONENT_ADD_FILE_SERVER_REQUEST = 'COMPONENT_ADD_FILE_SERVER_REQUEST',
  COMPONENT_ADD_FILE_SERVER_SUCCESS = 'COMPONENT_ADD_FILE_SERVER_SUCCESS',
  COMPONENT_ADD_FILE_SERVER_FAILURE = 'COMPONENT_ADD_FILE_SERVER_FAILURE',
  COMPONENT_GET_FILE_SERVER_REQUEST = 'COMPONENT_GET_FILE_SERVER_REQUEST',
  COMPONENT_GET_FILE_SERVER_SUCCESS = 'COMPONENT_GET_FILE_SERVER_SUCCESS',
  COMPONENT_GET_FILE_SERVER_FAILURE = 'COMPONENT_GET_FILE_SERVER_FAILURE',
  COMPONENT_REMOVE_FILE_SERVER_REQUEST = 'COMPONENT_REMOVE_FILE_SERVER_REQUEST',
  COMPONENT_REMOVE_FILE_SERVER_SUCCESS = 'COMPONENT_REMOVE_FILE_SERVER_SUCCESS',
  COMPONENT_REMOVE_FILE_SERVER_FAILURE = 'COMPONENT_REMOVE_FILE_SERVER_FAILURE',
  COMPONENT_REMOVE_FILE_ENTRY_LOCALLY = 'COMPONENT_REMOVE_FILE_ENTRY_LOCALLY';

/* ----------------------------------------------- */
/* ---------- Staff ------------------------------- */
/* ------------------------------------------------ */
export const ROLES_GET_ALL_REQUEST = 'ROLES_GET_ALL_REQUEST',
  ROLES_GET_ALL_SUCCESS = 'ROLES_GET_ALL_SUCCESS',
  ROLES_GET_ALL_FAILURE = 'ROLES_GET_ALL_FAILURE',
  USERS_GET_ALL_REQUEST = 'USERS_GET_ALL_REQUEST',
  USERS_GET_ALL_SUCCESS = 'USERS_GET_ALL_SUCCESS',
  USERS_GET_ALL_FAILURE = 'USERS_GET_ALL_FAILURE',
  INVITE_REQUESTS_GET_ALL_REQUEST = 'INVITE_REQUESTS_GET_ALL_REQUEST',
  INVITE_REQUESTS_GET_ALL_SUCCESS = 'INVITE_REQUESTS_GET_ALL_SUCCESS',
  INVITE_REQUESTS_GET_ALL_FAILURE = 'INVITE_REQUESTS_GET_ALL_FAILURE',
  ROLE_ADD_REQUEST = 'ROLE_ADD_REQUEST',
  ROLE_ADD_SUCCESS = 'ROLE_ADD_SUCCESS',
  ROLE_ADD_FAILURE = 'ROLE_ADD_FAILURE',
  STAFF_INVITE_REQUEST = 'STAFF_INVITE_REQUEST',
  STAFF_INVITE_SUCCESS = 'STAFF_INVITE_SUCCESS',
  STAFF_INVITE_FAILURE = 'STAFF_INVITE_FAILURE',
  STAFF_REMOVE_REQUEST = 'STAFF_REMOVE_REQUEST',
  STAFF_REMOVE_SUCCESS = 'STAFF_REMOVE_SUCCESS',
  STAFF_REMOVE_FAILURE = 'STAFF_REMOVE_FAILURE',
  RESET_STAFF_STATE = 'RESET_STAFF_STATE',
  USER_ROLE_GET_REQUEST = 'USER_ROLE_GET_REQUEST',
  USER_ROLE_GET_SUCCESS = 'USER_ROLE_GET_SUCCESS',
  USER_ROLE_GET_FAILURE = 'USER_ROLE_GET_FAILURE',
  USER_ROLE_UPDATE_REQUEST = 'USER_ROLE_UPDATE_REQUEST',
  USER_ROLE_UPDATE_SUCCESS = 'USER_ROLE_UPDATE_SUCCESS',
  USER_ROLE_UPDATE_FAILURE = 'USER_ROLE_UPDATE_FAILURE',
  STAFF_ROSTER_UPDATE_REQUEST = 'STAFF_ROSTER_UPDATE_REQUEST',
  STAFF_ROSTER_UPDATE_SUCCESS = 'STAFF_ROSTER_UPDATE_SUCCESS',
  STAFF_ROSTER_UPDATE_FAILURE = 'STAFF_ROSTER_UPDATE_FAILURE',
  STAFF_ROSTER_FETCH_REQUEST = 'STAFF_ROSTER_FETCH_REQUEST',
  STAFF_ROSTER_FETCH_SUCCESS = 'STAFF_ROSTER_FETCH_SUCCESS',
  STAFF_ROSTER_FETCH_FAILURE = 'STAFF_ROSTER_FETCH_FAILURE',
  FB_STAFF_ROSTER_UPDATED = 'FB_STAFF_ROSTER_UPDATED';

/* ------------------------------------------------------------ */
/* ----------------- CONSULTS -------------------------------- */
/* ------------------------------------------------------------ */
export const CONSULT_REFERRAL_SEND_REQUEST = 'CONSULT_REFERRAL_SEND_REQUEST';
export const CONSULT_REFERRAL_SEND_SUCCESS = 'CONSULT_REFERRAL_SEND_SUCCESS';
export const CONSULT_REFERRAL_SEND_FAILURE = 'CONSULT_REFERRAL_SEND_FAILURE';
export const FETCH_OUTBOUND_REFERRALS_REQUEST = 'FETCH_OUTBOUND_REFERRALS_REQUEST';
export const FETCH_OUTBOUND_REFERRALS_SUCCESS = 'FETCH_OUTBOUND_REFERRALS_SUCCESS';
export const FETCH_OUTBOUND_REFERRALS_FAILURE = 'FETCH_OUTBOUND_REFERRALS_FAILURE';
export const FETCH_INBOUND_REFERRALS_REQUEST = 'FETCH_INBOUND_REFERRALS_REQUEST';
export const FETCH_INBOUND_REFERRALS_SUCCESS = 'FETCH_INBOUND_REFERRALS_SUCCESS';
export const FETCH_INBOUND_REFERRALS_FAILURE = 'FETCH_INBOUND_REFERRALS_FAILURE';
export const SUBMIT_CONSULT_REFERRAL_REQUEST = 'SUBMIT_CONSULT_REFERRAL_REQUEST';
export const SUBMIT_CONSULT_REFERRAL_SUCCESS = 'SUBMIT_CONSULT_REFERRAL_SUCCESS';
export const SUBMIT_CONSULT_REFERRAL_FAILURE = 'SUBMIT_CONSULT_REFERRAL_FAILURE';
export const UPDATE_CONSULT_REFERRAL_STATUS_REQUEST = 'UPDATE_CONSULT_REFERRAL_STATUS_REQUEST';
export const UPDATE_CONSULT_REFERRAL_STATUS_SUCCESS = 'UPDATE_CONSULT_REFERRAL_STATUS_SUCCESS';
export const UPDATE_CONSULT_REFERRAL_STATUS_FAILURE = 'UPDATE_CONSULT_REFERRAL_STATUS_FAILURE';
export const RESET_CONSULT_REFERRAL_STATE = 'RESET_CONSULT_REFERRAL_STATE';
export const SELECT_CONSULT_REFERRAL = 'SELECT_CONSULT_REFERRAL';
export const CLOSE_CONSULT_REFERRAL_REQUEST = 'CLOSE_CONSULT_REFERRAL_REQUEST';
export const CLOSE_CONSULT_REFERRAL_SUCCESS = 'CLOSE_CONSULT_REFERRAL_SUCCESS';
export const CLOSE_CONSULT_REFERRAL_FAILURE = 'CLOSE_CONSULT_REFERRAL_FAILURE';
export const SET_CONSULT_REFERRAL_CONFIRMATION = 'SET_CONSULT_REFERRAL_CONFIRMATION';

/* ------------------------------------------------------------ */
/* ----------------- STAFF SCHEDULING -------------------------------- */
/* ------------------------------------------------------------ */
export const RESET_STAFF_SCHEDULE_STATE = 'RESET_STAFF_SCHEDULE_STATE';
export const SAVE_STAFF_SCHEDULE_REQUEST = 'SAVE_STAFF_SCHEDULE_REQUEST';
export const SAVE_STAFF_SCHEDULE_SUCCESS = 'SAVE_STAFF_SCHEDULE_SUCCESS';
export const SAVE_STAFF_SCHEDULE_FAILURE = 'SAVE_STAFF_SCHEDULE_FAILURE';
export const GET_STAFF_SCHEDULE_REQUEST = 'GET_STAFF_SCHEDULE_REQUEST';
export const GET_STAFF_SCHEDULE_SUCCESS = 'GET_STAFF_SCHEDULE_SUCCESS';
export const GET_STAFF_SCHEDULE_FAILURE = 'GET_STAFF_SCHEDULE_FAILURE';
export const GET_STAFF_SCHEDULE_FOR_DATES_REQUEST = 'GET_STAFF_SCHEDULE_FOR_DATES_REQUEST';
export const GET_STAFF_SCHEDULE_FOR_DATES_SUCCESS = 'GET_STAFF_SCHEDULE_FOR_DATES_SUCCESS';
export const GET_STAFF_SCHEDULE_FOR_DATES_FAILURE = 'GET_STAFF_SCHEDULE_FOR_DATES_FAILURE';
export const STAFF_SCHEDULE_UPDATES = 'STAFF_SCHEDULE_UPDATES';
export const EXPORT_STAFF_SCHEDULE_REQUEST = 'EXPORT_STAFF_SCHEDULE_REQUEST';
export const EXPORT_STAFF_SCHEDULE_SUCCESS = 'EXPORT_STAFF_SCHEDULE_SUCCESS';
export const EXPORT_STAFF_SCHEDULE_FAILURE = 'EXPORT_STAFF_SCHEDULE_FAILURE';
export const GET_UNLOCKED_STAFF_SCHEDULE_MONTH_REQUEST =
  'GET_UNLOCKED_STAFF_SCHEDULE_MONTH_REQUEST';
export const GET_UNLOCKED_STAFF_SCHEDULE_MONTH_SUCCESS =
  'GET_UNLOCKED_STAFF_SCHEDULE_MONTH_SUCCESS';
export const GET_UNLOCKED_STAFF_SCHEDULE_MONTH_FAILURE =
  'GET_UNLOCKED_STAFF_SCHEDULE_MONTH_FAILURE';
export const STAFF_SCHEDULE_REGION_UNLOCKABLE_DATE = 'STAFF_SCHEDULE_REGION_UNLOCKABLE_DATE';

export const PART_A_GET_AUTH_TOKEN_REQUEST = 'PART_A_GET_AUTH_TOKEN_REQUEST';
export const PART_A_GET_AUTH_TOKEN_FAILURE = 'PART_A_GET_AUTH_TOKEN_FAILURE';
export const PART_A_GET_AUTH_TOKEN_SUCCESS = 'PART_A_GET_AUTH_TOKEN_SUCCESS';
export const PART_A_REQUEST_SECURITY_EMAIL_REQUEST = 'PART_A_REQUEST_SECURITY_EMAIL_REQUEST';
export const PART_A_REQUEST_SECURITY_EMAIL_FAILURE = 'PART_A_REQUEST_SECURITY_EMAIL_FAILURE';
export const PART_A_REQUEST_SECURITY_EMAIL_SUCCESS = 'PART_A_REQUEST_SECURITY_EMAIL_SUCCESS';
export const PART_A_GET_DATA_REQUEST = 'PART_A_GET_DATA_REQUEST';
export const PART_A_GET_DATA_SUCCESS = 'PART_A_GET_DATA_SUCCESS';
export const PART_A_GET_DATA_FAILURE = 'PART_A_GET_DATA_FAILURE';
export const PART_A_SAVE_DATA_REQUEST = 'PART_A_SAVE_DATA_REQUEST';
export const PART_A_SAVE_DATA_SUCCESS = 'PART_A_SAVE_DATA_SUCCESS';
export const PART_A_SAVE_DATA_FAILURE = 'PART_A_SAVE_DATA_FAILURE';
export const PART_A_CLEAR_TOKEN = 'PART_A_CLEAR_TOKEN';
export const PART_A_RESET = 'PART_A_RESET';
export const PART_A_SCREEN_STATE = 'PART_A_SCREEN_STATE';
export const PART_A_SUBMIT_FORM_REQUEST = 'PART_A_SUBMIT_FORM_REQUEST';
export const PART_A_SUBMIT_FORM_SUCCESS = 'PART_A_SUBMIT_FORM_SUCCESS';
export const PART_A_SUBMIT_FORM_FAILURE = 'PART_A_SUBMIT_FORM_FAILURE';
